<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="wdays"
    item-text="name"
    item-value="code"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    dark>
  </v-select>
</template>

<script>
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    computed: {
      wdays () {
        return [0, 1, 2, 3, 4, 5, 6]
          .map(d => ({ code: d, name: this.$t(`inputs.weekday.wday.${d}`) }))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/WeekDay.vue